module.exports = __webpack_public_path__ + "img/conspectLogo.c91d7974.svg";